<template>
  <el-select
    ref="product"
    v-model="selectValue"
    filterable
    remote
    reserve-keyword
    placeholder="请输入关键词"
    :remote-method="remoteMethod"
    :loading="loading"
    :disabled="isDisabled"
    style="width:100%;"
    value-key="code"
    @change="change"
  >
    <el-option
      v-for="(item,index) in list"
      :key="index"
      :label="item.name"
      :value="item"
    >
      <span style="float: left;style:inline-block">型号：{{ item.name }}</span>
      <span style="float: right;style:inline-block;margin-left:10px">销售代码：{{ item.code }}</span>
    </el-option>
  </el-select>
</template>
<script type="es6">
import { getAutoProductInfo } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      isDisabled: false,
      selectValue: '',
      loading: false
    };
  },
  props: {
    row: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getAutoProductInfo(query).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      if (this.row) {
        this.$set(this.row, 'rproductCode', val.code);
        // this.row.productCode = val.code;
        this.row.rproductName = val.name;
        this.row.materialNumberId = '';
        this.row.materialUnit = '';
        this.row.unit = val.unit;
        this.row.splitType = val.orderSplitType;
        this.row.salesInvoiceName = val.invoiceName;
        this.row.salesProductName = val.salesProductName;
        // this.row.isHavePowerCord = val.havePowerCord ? val.havePowerCord : (this.row.isHavePowerCord ? this.row.isHavePowerCord : false);// 电源线
        if (val.havePowerCord !== null && val.havePowerCord !== undefined) {
          this.row.isHavePowerCord = val.havePowerCord;
        } else {
          if (this.row.isHavePowerCord !== null && this.row.isHavePowerCord !== undefined) {
            this.row.isHavePowerCord = this.row.isHavePowerCord;
          } else {
            this.row.isHavePowerCord = false;
          }
        }
        // this.row.isHavePowerCord = true;// 电源线
      }
    },
    initData () {
      if (this.row.rproductCode) {
        this.list = [{
          'name': this.row.rproductName,
          'code': this.row.rproductCode
        }];
        this.$nextTick(() => {
          this.selectValue = {
            'name': this.row.rproductName,
            'code': this.row.rproductCode
          };
        });
      }
      if (this.row.cloudDesktopMatching !== undefined) {
        this.isDisabled = this.row.cloudDesktopMatching;
      }
    }
  },
  mounted () {
    this.initData();
  },
  watch: {
    row (val) {
      if (val.rproductCode !== this.selectValue.code) {
        this.initData();
      }
    }
  }
};
</script>
